import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    height: 100%;
    gap: 20px;   

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 10px; 
    }
`;

export const Sidebar = styled.div`
    width: 223px;
    padding: 0.5rem 1.5rem;
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (max-width: 768px) {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #eee;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }
`;

export const CropperWrapper = styled.div`
    position: relative;
    flex: 1;
    display: flex !important;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    padding: 40px;

    @media (max-width: 768px) {
        height: 100px;
        margin: 2rem 2rem;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const HeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    flex-wrap: wrap;
    gap: 1rem;

    @media (max-width: 1280px) {
        margin-bottom: 24px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start; 
        max-width: 100%;
    }
`;

export const ResponsiveText = styled.div`
    width: 441px;
    height: 32px;
    text-align: left;
    font: normal normal normal 14px/16px Manrope;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;

    @media (max-width: 1280px) {
        width: 100%;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin-top: -10px;
    }
`;


export const TextContainer = styled.div`
    display: flex;
    flex-direction: row;   
    align-items: center;  
    gap: 20px;          
    max-width: 70%;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        max-width: 100%;
        width: 100%;
        gap: 0px;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 15px;
    margin-right: 20px;

    @media (max-width: 768px) {
        margin-right: 0;
        flex-direction: row;   

        button {
        flex: 1;            
        min-width: 0;    
        }
    }
`;

export const AspectBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
    gap: 4px;
`;

export const AspectLabel = styled.p`
    width: 57px;            
    text-align: center;   
    font-size: 12px;
    color: #333;
    margin: 0;
`;

export const Wrapper = styled.div`
    margin-top: ${p => p.marginTop || "0px"};
    @media (max-width: 768px) {
        margin-bottom: 10px;
    }
`;

export const ToggleContainer = styled.div`
    display: flex;
    width: 123px;
    height: 57px;
    border: 1px solid #dee0e6;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #0000001a;
`;

export const ModeBox = styled.div`
    width: 63px;
    height: 57px;
    background-color: #ffffff;
    border: ${(props) => (props.isSelected ? "2px solid #D8DEEC" : "none")};
    box-shadow: 0px 3px 6px #0000001a;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    cursor: ${(props) => (props.isAllowed ? "pointer" : "not-allowed")};
    opacity: ${(props) => (props.isAllowed ? 1 : 0.3)};
    pointer-events: ${(props) => (props.isAllowed ? "auto" : "none")};
`;

export const ModeInnerBox = styled.div`
    width: ${(props) => (props.mode === "landscape" ? "38px" : "21px")};
    height: ${(props) => (props.mode === "landscape" ? "21px" : "38px")};
    background-color: ${(props) => (props.isSelected ? "#D8DEEC" : "transparent")};
    border: 2px solid #8291b2;
    border-radius: 5px;
`;

export const AspectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 2rem;
    width: 100%;

     @media (max-width: 768px) {
          width: 50%;
    }
`;

export const AspectSelectableBox = styled.div`
    width: 57px;
    height: 57px;
    background-color: #fff;
    box-shadow: 0px 3px 6px #0000001a;
    border-radius: 10px;
    border: ${(props) => (props.isSelected ? "2px solid #36BE25" : "1px solid #DEE0E6")};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    position: relative;
`;

export const AspectInnerBox = styled.div`
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    background-color: #8291b2;
    border-radius: 5px;
`;

export const CheckmarkWrapper = styled.div`
    position: absolute;
    top: -8px;
    right: -8px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

export const ImagePickerLabel = styled.label`
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99999;
    cursor: pointer;
`;

export const ImageButton = styled.div`
    width: 140px;
    height: 38px;
    background: #efe7ff;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #633fe4;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #633fe4;
    font-family: Manrope, sans-serif;
    font-size: 14px;
    font-weight: 500;
`;

export const ZoomControls = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
    display: flex;
    gap: 8px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    padding: 6px 10px;
    align-items: center;
`;

export const ZoomButton = styled.button`
    background: none;
    border: none;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;

    &:hover {
        background-color: ${({ disabled }) => (disabled ? "none" : "rgba(255,255,255,0.1)")};
    }
`;
